import React from 'react';
import Divider from '../divider/divider.component';
import SectionTitle from '../section-title/section-title.component';
import './about.styles.scss';

const About = () => {
    return (
        <div className='about' id='nosotros'>
            <SectionTitle
                type='h2'
                mainTitle='NOSOTROS'
            />
            <article className='description'>
                <p>
                    El estudio de Arquitectura tiene más de 25 años de
                    trayectoria en el país. Sus obras guandardistas han creado
                    un nuevo estilo de vida para mejorar la relación entre el
                    hombre, su hábitat y la naturaleza.
                </p>
                <img
                    src='images/general/about/about_01.jpg'
                    alt='Sobre Nosotros'
                />
            </article>
            <Divider />
        </div>
    );
};

export default About;
